import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import Header from "./navigation/Header";
import Footer from "./navigation/Footer";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { GetAD, GetController } from "../../store/actions/adcardActions";
import { GetBusinessProfile } from "../../store/actions/profileActions";
import {
  GetTimeSlots,
  GetDestinations,
  GetCarModels,
} from "../../store/actions/regionActions";
import Loading from "../widgets/Loading";
import { numberWithCommas } from "../../functions/utils";
import DataTable from "react-data-table-component";
import completed from "../../assets/images/completed.png";

class BusinessADPage extends Component {
  state = {
    fixclaimreason: "",
    fixclaimmodal: false,
    remainingdates: 0,
    tascpd: [],
    adsetup: [],
    adcard: {},
    sett: false,
  };

  PREDICTIONCOLUMNS = [
    {
      name: "DATE",
      selector: "date",
      cell: (t) => <p>{t.date.toDateString()}</p>,
      sortable: true,
    },
    {
      name: "VALUE",
      cell: (t) => <p>{numberWithCommas(t.value)}</p>,
      selector: "value",
      sortable: true,
    },
  ];

  UNIQUECOLUMNS = [
    {
      name: "Vehicle Type",
      selector: "cm",
      cell: (t) => <p>{t.cm}</p>,
      sortable: true,
    },
    {
      name: "Time Slot",
      cell: (t) => <p>{t.ts}</p>,
      selector: "ts",
    },
    {
      name: "Routes",
      cell: (t) => <p>{t.sp}</p>,
      selector: "sp",
    },
    {
      name: "People Reached",
      cell: (t) => (
        <p>
          {t.value !== undefined && t.value !== null
            ? numberWithCommas(t.value)
            : 0}
        </p>
      ),
      selector: "value",
      sortable: true,
    },
  ];

  STYLES = {
    headCells: {
      style: {
        fontSize:
          "calc( 1.07rem + (1.2 - 1.07) * ((100vw - 20rem) / (48 - 20)))",
        lineHeight:
          "calc( 1.4 * (1.07rem + (1.2 - 1.07) * ((100vw - 20rem) / (48 - 20))))",
        wordBreak: "break-word",
        wordWrap: "break-word",
      },
    },
    cells: {
      style: {
        fontSize:
          "calc( 1.07rem + (1.2 - 1.15) * ((100vw - 20rem) / (48 - 20)))",
        lineHeight:
          "calc( 1.4 * (1.07rem + (1.15 - 1.07) * ((100vw - 20rem) / (48 - 20))))",
        wordBreak: "break-word",
        wordWrap: "break-word",
        fontWeight: "400",
      },
    },
  };

  handleOk = () => {
    this.setState({
      fixclaimmodal: false,
      fixclaimid: "",
    });
  };

  handleCancel = () => {
    this.setState({
      fixclaimmodal: false,
      fixclaimid: "",
    });
  };

  componentDidMount() {
    document.title = "Loading...";

    if (
      this.props.profile.profile !== null &&
      this.props.profile.region !== null
    ) {
      this.props.getAdCard(this.props.match.params.ticker_symbol);
      this.props.getController();
    }
  }

  componentDidUpdate(prev, curr) {
    if (this.props.profile.profile === null) {
      if (
        prev.firebase.profile.isLoaded === false &&
        this.props.firebase.profile.isLoaded === true
      ) {
        this.props.getBusiness();
      }
    } else if (
      this.props.profile.profile !== prev.profile.profile &&
      this.props.profile.profile !== null
    ) {
      this.props.getAdCard(this.props.match.params.adid);
    } else if (
      this.props.profile.region !== prev.profile.region &&
      this.props.profile.region !== null
    ) {
      this.props.getController();
    } else if (
      this.props.adcard.adcard.get(this.props.match.params.adid) !==
        undefined &&
      this.props.adcard.controller !== null &&
      this.state.remainingdates === 0 &&
      !this.state.sett
      // &&
      // prev.adcard.adcard.get(this.props.match.params.adid) !==
      //   this.props.adcard.adcard.get(this.props.match.params.adid)
    ) {
      var temptascpd = [];
      if (this.props.adcard.adcard.has(this.props.match.params.adid)) {
        document.title = this.props.adcard.adcard.get(
          this.props.match.params.adid
        ).name;
        if (
          this.props.adcard.adcard.get(this.props.match.params.adid).completed
        ) {
          this.setState({
            remainingdates: 0,
            sett: true,
          });
        } else {
          console.log(
            this.props.adcard.adcard.get(this.props.match.params.adid).tascpd
          );
          this.props.adcard.adcard
            .get(this.props.match.params.adid)
            .tascpd.forEach((td) => {
              try {
                if (td.date.toDate() > new Date()) {
                  // console.log("more than today");
                  temptascpd.push({
                    date: td.date.toDate(),
                    value: parseInt(
                      Math.floor(
                        td.value /
                          this.props.adcard.adcard.get(
                            this.props.match.params.adid
                          ).length
                      )
                    ),
                  });
                }
              } catch (e) {
                console.log("ERROR");
                console.log(e);
              }
            });
          const asipdatee = this.props.adcard.controller.asipDate.toDate();

          const newdatea = new Date(
            asipdatee.setDate(
              asipdatee.getDate() +
                this.props.adcard.adcard.get(this.props.match.params.adid).sda
            )
          );
          this.setState({
            remainingdates:
              new Date().setHours(0, 0, 0, 0) - newdatea.setHours(0, 0, 0, 0),
            sett: true,
            tascpd: temptascpd,
          });
        }
      }

      if (this.props.adcard.adcard.has(this.props.match.params.adid)) {
        if (
          this.props.adcard.adcard.get(this.props.match.params.adid).adsetup
            .length > 0
        ) {
          this.props.getTimeSlots();
          this.props.getDestinations();
          this.props.getCarModels();
        }
      }
    } else if (
      this.props.adcard.adcard.get(this.props.match.params.adid) !==
        undefined &&
      this.props.adcard.adcard.get(this.props.match.params.adid).adsetup
        .length > 0 &&
      this.props.adcard.controller !== null &&
      this.props.region.timeslotsloading === false &&
      this.props.region.destinationsloading === false &&
      this.props.region.carmodelsloading === false &&
      this.state.adsetup.length === 0
    ) {
      document.title = this.props.adcard.adcard.get(
        this.props.match.params.adid
      ).name;
      var tempadsetup = [];
      this.props.adcard.adcard
        .get(this.props.match.params.adid)
        .adsetup.forEach((setupp) => {
          if (setupp.value > 0) {
            var tempobj = {
              cm: "-",
              sp: "-",
              ts: "-",
              value: setupp.value,
            };
            if (this.props.region.carmodels.length > 0) {
              var filteredcms = this.props.region.carmodels.filter(function (
                event
              ) {
                return event.id === setupp.cm;
              });
              if (filteredcms.length === 1) {
                tempobj.cm = filteredcms[0].name;
              }
            }
            if (this.props.region.timeslots.length > 0) {
              try {
                var filteredtss = this.props.region.timeslots.filter(function (
                  event
                ) {
                  return event.id === setupp.ts;
                });
                var tmp = "";
                if (filteredtss.length === 1) {
                  tmp = filteredtss[0].startTime.toDate().getHours();
                  var startime = "";
                  var endtime = "";
                  if (tmp >= 12) {
                    startime =
                      filteredtss[0].startTime.toDate().getHours() -
                      (12).toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }) +
                      ":" +
                      filteredtss[0].startTime
                        .toDate()
                        .getMinutes()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      " pm";
                  } else {
                    startime =
                      filteredtss[0].startTime
                        .toDate()
                        .getHours()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      ":" +
                      filteredtss[0].startTime
                        .toDate()
                        .getMinutes()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      " am";
                  }
                  tmp = filteredtss[0].endTime.toDate().getHours();
                  if (tmp >= 12) {
                    endtime =
                      filteredtss[0].endTime.toDate().getHours() -
                      (12).toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false,
                      }) +
                      ":" +
                      filteredtss[0].endTime
                        .toDate()
                        .getMinutes()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      " pm";
                  } else {
                    endtime =
                      filteredtss[0].endTime
                        .toDate()
                        .getHours()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      ":" +
                      filteredtss[0].endTime
                        .toDate()
                        .getMinutes()
                        .toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) +
                      " am";
                  }
                  tempobj.ts = startime + " - " + endtime;
                }
              } catch (e) {
                console.log(e);
              }
            }
            if (this.props.region.destinations.length > 0) {
              var filteredsps = this.props.region.destinations.filter(function (
                event
              ) {
                return event.id === setupp.sp;
              });
              if (filteredsps.length === 1) {
                tempobj.sp = filteredsps[0].destination;
              }
            }
            tempadsetup.push(tempobj);
          }
        });
      this.setState({
        adsetup: tempadsetup,
      });
    }
  }

  render() {
    if (this.props.auth.uid && !this.props.auth.isAnonymous) {
      if (
        !this.props.adcard.adcardloading &&
        !this.props.adcard.controllerloading &&
        this.props.adcard.controller !== null &&
        this.props.adcard.adcard.has(this.props.match.params.adid)
      ) {
        return (
          <div>
            <Header />
            <div className="fullContainer">
              <section
                className="features17 cid-ssS9AYL8y5 adpage"
                id="features18-1p"
              >
                <div className="container businessadcard">
                  <div className="item features-image сol-12">
                    <div className="item-wrapper">
                      <div className="item-content">
                        <div className="container">
                          <div className="row">
                            <div className="сol-8 col-lg-6 col-md-12 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Name
                              </p>
                              <h5 className="item-title mbr-fonts-style display-5">
                                <strong>
                                  {this.props.adcard.adcard.has(
                                    this.props.match.params.adid
                                  )
                                    ? this.props.adcard.adcard.get(
                                        this.props.match.params.adid
                                      ).name
                                    : ""}
                                </strong>
                              </h5>
                            </div>
                            {!this.props.adcard.adcard.get(
                              this.props.match.params.adid
                            ).completed ? (
                              <div className="сol-3 col-lg-3 col-md-6">
                                <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                  Remaining Balance
                                </p>
                                <h5 className="item-title mbr-fonts-style display-7">
                                  <strong>
                                    {this.props.adcard.adcard.has(
                                      this.props.match.params.adid
                                    )
                                      ? this.props.adcard.adcard.get(
                                          this.props.match.params.adid
                                        ).adCardBalance !== null &&
                                        this.props.adcard.adcard.get(
                                          this.props.match.params.adid
                                        ).adCardBalance !== undefined
                                        ? numberWithCommas(
                                            this.props.adcard.adcard
                                              .get(this.props.match.params.adid)
                                              .adCardBalance.toFixed(2)
                                          ) + " ETB"
                                        : "0.00 ETB"
                                      : "-"}
                                  </strong>
                                </h5>
                              </div>
                            ) : (
                              <div className="сol-3 col-lg-3 col-md-6"></div>
                            )}
                            <div className="сol-3 col-lg-3 col-md-6 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9 text-right">
                                Today's Status
                              </p>
                              <h5 className="item-title mbr-fonts-style display-5 text-right">
                                <strong
                                  style={
                                    this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).completed
                                      ? { color: "green" }
                                      : this.props.adcard.adcard.get(
                                          this.props.match.params.adid
                                        ).servingToday
                                      ? { color: "green" }
                                      : { color: "red" }
                                  }
                                >
                                  {this.props.adcard.adcard.get(
                                    this.props.match.params.adid
                                  ).completed ? (
                                    <div className="row">
                                      <div className="col">
                                        <span>Completed</span>
                                      </div>
                                      <div
                                        style={{
                                          width: "2rem",
                                        }}
                                        className="d-flex align-items-center justify-content-center"
                                      >
                                        <img
                                          src={completed}
                                          style={{
                                            width: "2rem",
                                          }}
                                          className="completed"
                                          alt=""
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  ) : this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).servingToday ? (
                                    "Serving"
                                  ) : (
                                    "Not Serving"
                                  )}
                                </strong>
                              </h5>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="сol-4 col-md-4">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Start Date
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).start_date !== undefined &&
                                this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).start_date !== null
                                  ? this.props.adcard.adcard
                                      .get(this.props.match.params.adid)
                                      .start_date.toDate()
                                      .toDateString()
                                  : "-"}
                              </h5>
                            </div>
                            <div className="сol-4 col-md-4">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                {this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).completed
                                  ? "Final Date"
                                  : "Expire Date"}
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).end_date !== undefined &&
                                this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).end_date !== null
                                  ? this.props.adcard.adcard
                                      .get(this.props.match.params.adid)
                                      .end_date.toDate()
                                      .toDateString()
                                  : "-"}
                              </h5>
                            </div>
                            {!this.props.adcard.adcard.get(
                              this.props.match.params.adid
                            ).completed ? (
                              <div className="сol-4 col-md-4 ">
                                <p className="mbr-text ads-name-text mbr-fonts-style display-9 text-right">
                                  Approval
                                </p>
                                <h5 className="item-title mbr-fonts-style display-7 text-right">
                                  <strong
                                    style={
                                      this.props.adcard.adcard.has(
                                        this.props.match.params.adid
                                      )
                                        ? this.props.adcard.adcard.get(
                                            this.props.match.params.adid
                                          ).status > 0
                                          ? this.props.adcard.adcard.get(
                                              this.props.match.params.adid
                                            ).status === 1
                                            ? { color: "green" }
                                            : { color: "red" }
                                          : { color: "black" }
                                        : {}
                                    }
                                  >
                                    {this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).status > 0
                                      ? this.props.adcard.adcard.get(
                                          this.props.match.params.adid
                                        ).status === 1
                                        ? "Approved"
                                        : "Not Approved"
                                      : "Pending"}
                                  </strong>
                                </h5>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="сol-4 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Remaining Days (Approx.)
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                <strong>
                                  {this.state.remainingdates <= 0
                                    ? Math.floor(
                                        Math.abs(
                                          this.state.remainingdates /
                                            (1000 * 60 * 60 * 24)
                                        )
                                      )
                                    : "Unknown"}
                                </strong>
                              </h5>
                            </div>
                            <div className="сol-4 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                People Reached (Approx.)
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {
                                  this.props.adcard.adcard.get(
                                    this.props.match.params.adid
                                  ).totalServedAmount
                                }
                              </h5>
                            </div>
                            <div className="сol-4 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Routes Covered
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {
                                  this.props.adcard.adcard.get(
                                    this.props.match.params.adid
                                  ).totalNumberOfAdsServed
                                }
                              </h5>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="сol-3 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Paid Fee
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).amountPaid !== null &&
                                this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).amountPaid !== undefined
                                  ? numberWithCommas(
                                      this.props.adcard.adcard
                                        .get(this.props.match.params.adid)
                                        .amountPaid.toFixed(2)
                                    )
                                  : "-"}{" "}
                                ETB
                              </h5>
                            </div>
                            <div className="сol-3 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Refund
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).refund !== null &&
                                this.props.adcard.adcard.get(
                                  this.props.match.params.adid
                                ).refund !== undefined
                                  ? numberWithCommas(
                                      this.props.adcard.adcard
                                        .get(this.props.match.params.adid)
                                        .refund.toFixed(2)
                                    )
                                  : "-"}{" "}
                                ETB
                              </h5>
                            </div>
                            <div className="сol-3 col-md-4 ">
                              <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                                Net Cost
                              </p>
                              <h5 className="item-title mbr-fonts-style display-7">
                                {this.props.adcard.adcard.has(
                                  this.props.match.params.adid
                                )
                                  ? this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).refund !== null &&
                                    this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).refund !== undefined &&
                                    this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).amountPaid !== null &&
                                    this.props.adcard.adcard.get(
                                      this.props.match.params.adid
                                    ).amountPaid !== undefined
                                    ? numberWithCommas(
                                        (
                                          this.props.adcard.adcard.get(
                                            this.props.match.params.adid
                                          ).amountPaid -
                                          this.props.adcard.adcard.get(
                                            this.props.match.params.adid
                                          ).refund
                                        ).toFixed(2)
                                      )
                                    : "-"
                                  : ""}{" "}
                                ETB
                              </h5>
                            </div>
                            {this.props.profile.systemuser && (
                              <div className="сol-3 col-md-12 text-right ">
                                <a
                                  href="#callus"
                                  className="btn btn-black display-3 txnclaimforfix"
                                >
                                  Report an Error
                                </a>
                              </div>
                            )}
                          </div>
                          <br />
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {this.props.adcard.adcard.has(this.props.match.params.adid)
                ? this.state.tascpd.length > 0 &&
                  !this.props.adcard.adcard.get(this.props.match.params.adid)
                    .completed && (
                    <section
                      className="section-table cid-ssS3CJ4LIn"
                      id="table1-1g"
                    >
                      <div className="container container-table">
                        <h2 className="mbr-section-title mbr-fonts-style align-center pb-3 display-2">
                          AD Serving Prediction
                        </h2>
                      </div>

                      <div className="table-wrapper">
                        <div className="container scroll col-10">
                          <DataTable
                            className="table isSearch"
                            columns={this.PREDICTIONCOLUMNS}
                            data={this.state.tascpd}
                            customStyles={this.STYLES}
                            pagination={true}
                          />
                        </div>
                      </div>
                      {/* //)} */}
                    </section>
                  )
                : ""}
              {this.state.adsetup.length > 0 && (
                <section
                  className="section-table cid-ssS3CJ4LIn"
                  id="table1-1g"
                >
                  <div className="container container-table">
                    <h2 className="mbr-section-title mbr-fonts-style align-center pb-3 display-2">
                      Unique People Reached on Each Setup (Approx.)
                    </h2>
                  </div>
                  {/* {this.props.fixclaim.loading ? (
          <Loading />
        ) : ( */}
                  <div className="table-wrapper">
                    <div className="container scroll col-10">
                      <DataTable
                        className="table isSearch"
                        columns={this.UNIQUECOLUMNS}
                        data={this.state.adsetup}
                        customStyles={this.STYLES}
                        pagination={true}
                      />
                    </div>
                  </div>
                  {/* //)} */}
                </section>
              )}
              {this.props.profile.systemuser && (
                <section
                  className="features17 cid-ssS9AYL8y5 callus"
                  id="callus"
                >
                  <div className="container">
                    <div className="row justify-content-center mt-4">
                      <div className="сol-8 col-md-8 ">
                        <p className="mbr-text ads-name-text mbr-fonts-style display-9  align-center">
                          If there is any problem you noticed with this
                          particular Advertisement, don't hesitate to call
                        </p>
                      </div>
                      <div className="сol-8 col-md-8 ">
                        <h5 className="item-title mbr-fonts-style display-5 align-center">
                          <a
                            href={
                              this.props.profile.systemuser &&
                              "tel:" + this.props.profile.systemuser.phone
                            }
                            className="text-primary"
                          >
                            <strong>
                              {this.props.profile.systemuser &&
                                this.props.profile.systemuser.phone}
                            </strong>
                          </a>
                        </h5>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
            <Footer />
          </div>
        );
      } else {
        return (
          <div className="row justify-content-center fullloading">
            <div className="col-lg-8 form-group">
              <Loading />
            </div>
          </div>
        );
      }
    } else {
      return <Redirect to="/" />;
    }
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
    adcard: state.adcard,
    region: state.region,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: () => dispatch(GetBusinessProfile()),
    getAdCard: (id) => dispatch(GetAD(id)),
    getController: () => dispatch(GetController()),
    getTimeSlots: () => dispatch(GetTimeSlots()),
    getDestinations: () => dispatch(GetDestinations()),
    getCarModels: () => dispatch(GetCarModels()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessADPage);
